export const DAYS_IN_WEEK = [
  {
    label: "Mo",
    value: "Monday",
    color: "#a8124a",
    backgroundColor: "#fdb1d1"
  },
  {
    label: "Tu",
    value: "Tuesday",
    color: "#9013FE",
    backgroundColor: "#E7CCFF"
  },
  {
    label: "We",
    value: "Wednesday",
    color: "#8b8b30",
    backgroundColor: "#fafabe"
  },
  {
    label: "Th",
    value: "Thursday",
    color: "#1473E6",
    backgroundColor: "#DAE9FC"
  },
  {
    label: "Fr",
    value: "Friday",
    color: "#FC5569",
    backgroundColor: "#FEE5DD"
  },
  {
    label: "Sa",
    value: "Saturday",
    color: "#479712",
    backgroundColor: "#d1f8b7"
  },
  {
    label: "Su",
    value: "Sunday",
    color: "#bd8504",
    backgroundColor: "#FFECC7"
  }
];
